// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';

// Components
import Button from '../../../components/buttons/Button';
import Icon from '../../../components/icons/Icon';
import ElementCreatePopup from './ElementCreatePopup';

// Actions
import { togglePopup } from '../../../components/popupPanel/popupActions';

// Styles
import './ElementCreateUtil.scss';
import { PopupIds } from '../../../components/popupPanel/popupConstants';

const mapDispatchToProps = (dispatch) => ({
    openPopupPanel: () => {
        dispatch(togglePopup(PopupIds.ELEMENT_CREATE));
    },
});

const ElementCreateUtil = (props) => {
    const { openPopupPanel, showCreateButton } = props;

    return (
        <div className={classNames('ElementCreateUtil', { leave: !showCreateButton })}>
            <Button className="highlight" onClickFn={openPopupPanel}>
                <div>
                    <Icon name="nav-create" />
                </div>
            </Button>
            <ElementCreatePopup {...props} />
        </div>
    );
};

ElementCreateUtil.propTypes = {
    openPopupPanel: PropTypes.func,
    showCreateButton: PropTypes.bool,
};

export default connect(null, mapDispatchToProps)(ElementCreateUtil);
